// extracted by mini-css-extract-plugin
module.exports = {"days":"Movies2026_days__3Z9cP"};